var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodHealthScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E09D19",
    fillOpacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 20.5714,
    fill: "#53AA14",
    fillOpacity: 0.32
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 16.4571,
    fill: "#53AA14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 24.4167C15.6665 23.4962 16.4127 22.75 17.3332 22.75C18.7139 22.75 19.8332 23.8692 19.8332 25.25V28.5833C19.8332 29.9641 18.7139 31.0833 17.3332 31.0833C16.4127 31.0833 15.6665 30.3372 15.6665 29.4167V24.4167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8991 20.5052L26.6772 21.2219C26.4953 21.8092 26.4044 22.1029 26.4743 22.3348C26.5309 22.5224 26.6551 22.6842 26.8243 22.7906C27.0335 22.9221 27.3499 22.9221 27.9827 22.9221H28.3194C30.4612 22.9221 31.532 22.9221 32.0378 23.5561C32.0956 23.6285 32.147 23.7056 32.1915 23.7864C32.5806 24.4934 32.1382 25.4459 31.2535 27.3509C30.4416 29.0991 30.0356 29.9732 29.2818 30.4877C29.2089 30.5374 29.1339 30.5844 29.0571 30.6284C28.2635 31.0833 27.2803 31.0833 25.3138 31.0833H24.8873C22.5049 31.0833 21.3137 31.0833 20.5736 30.3662C19.8335 29.6491 19.8335 28.4949 19.8335 26.1866V25.3752C19.8335 24.1622 19.8335 23.5557 20.0488 23.0005C20.2641 22.4453 20.6763 21.9889 21.5007 21.0759L24.9102 17.3005C24.9957 17.2058 25.0385 17.1584 25.0762 17.1256C25.4281 16.8194 25.9712 16.8539 26.2788 17.2019C26.3118 17.2392 26.3478 17.2916 26.4198 17.3963C26.5325 17.56 26.5888 17.6419 26.638 17.723C27.0775 18.4493 27.2105 19.312 27.0092 20.1309C26.9867 20.2224 26.9575 20.3167 26.8991 20.5052Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodHealthScore);
export default __webpack_public_path__ + "static/media/good-health-score.c23f9b2200af45465dc5713df35eeb87.svg";
export { ForwardRef as ReactComponent };